import { Button, Flex, Spacing, Text, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { CoinsDollarEuro } from '../../../../../../../../../../../../../../assets/images'
import { ModalId } from '../../../../../../../../../../../../../../enums/modalId'
import * as Styled from './styles'

export const PaymentMethodsBanner = (): ReactElement => {
  const { t } = useTranslation()
  const { open: openPaymentMethodsModal } = useModal(ModalId.InvoiceEditorPaymentMethodsModal)

  const handleSetupButtonClick = useCallback(() => {
    openPaymentMethodsModal()
  }, [openPaymentMethodsModal])

  return (
    <Styled.PaymentMethodsBannerWrapper>
      <Flex alignItems="center" gap={Spacing.S16} justifyContent="space-between">
        <Flex alignItems="center" gap={Spacing.S16}>
          <CoinsDollarEuro />
          <Text>{t('external_invoices.editor.payment_methods.banner.how_to_receive_payments')}</Text>
        </Flex>
        <div>
          <Button color="primary" icon="handCoins" onClick={handleSetupButtonClick} size="sm" variant="onColor">
            {t('external_invoices.editor.payment_methods.banner.setup_payment')}
          </Button>
        </div>
      </Flex>
    </Styled.PaymentMethodsBannerWrapper>
  )
}
